import api from './api';

export const verifySignupEmail = async (otpCode) => {
  const response = await api.post('/signup-verify-email', { otp_code: otpCode });
  return response.data;
};

export const resendSignupVerification = async () => {
  const response = await api.post('/signup-resend-verification', {});
  return response.data;
};

export const completeInvitedPasswordSetup = async ({
  password,
  password_confirmation,
}) => {
  const response = await api.post('/auth/complete-invited-password-setup', {
    password,
    password_confirmation,
  });
  return response.data;
};
